import { useState } from 'react';
import Landing from './pages/landing/Landing';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Spinner from './components/UI/spinner/Spinner';
import styles from './App.module.css';

//Okta imports
import { Security, LoginCallback } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { oktaAuthConfig } from './utils/config';

function App() {
  const [spinnerMessage, setSpinnerMessage] = useState<string | null>(null);
  const navigate = useNavigate();
  const oktaAuth = new OktaAuth(oktaAuthConfig);

  const restoreOriginalUri = async (_oktaAuth: any, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin), { replace: true });
  };

  return (
    <div className={styles.appContainer}>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <Routes>
          <Route path="/" element={<Landing setSpinnerMessage={setSpinnerMessage} />} />
          <Route path="/login/callback" element={<LoginCallback />} />
          <Route path="*" element={<Landing setSpinnerMessage={setSpinnerMessage} />} />
        </Routes>
        <Spinner message={spinnerMessage || undefined} />
      </Security>
    </div>
  );
}

export default App;
